// extracted by mini-css-extract-plugin
export default {"container":"PatchTestRequired--container--779999","questionIcon":"PatchTestRequired--questionIcon--4b5c26"};